import { Injectable, inject } from '@angular/core';

import { AlertProcess, Event } from '@co-assist/library';
import { ProcessService } from 'app/services/data/process.service';
import { Observable } from 'rxjs';
import { HelpedStoreService } from 'app/services/store/helped-store.service';

@Injectable()

export class ProcessResolver  {
    private processService = inject(ProcessService);
    private helpedStoreService = inject(HelpedStoreService);


    resolve(): Observable<Array<AlertProcess>> {
        const event: Event.User.GetProcessesEvent = {
            id: this.helpedStoreService.getCurrentHelpedID()
        };
        return this.processService.getProcesses(event);
    }
}
